import { Organization } from '../organizations/types'

export type OrganizationEvent = {
  id: number
  organizationId?: Organization['id']
  type: OrganizationEventType
  happenedOn: string
  createdAt: string
  updatedAt: string
}

export enum OrganizationEventType {
  adminOrganizationRelease = 'admin-organization-release',
  automaticOrganizationRelease = 'automatic-organization-release',
  networkManagerOrganizationRelease = 'network-manager-organization-release',
  roundClosed = 'round-closed',
  communicateRoundClosed = 'communicate-round-closed',
  organizationMatchmakingRelaunch = 'organization-matchmaking-relaunch',
  contactAttempt = 'contact-attempt',
  unableToReachCompany = 'unable-to-reach-company',
  currentlyNotFundraising = 'currently-not-fundraising',
  notInterestedInOurService = 'not-interested',
}

export type OrganizationEventData = Range | number | string

export type Range = {
  min: number
  max?: number
}
